module.exports = __webpack_public_path__ + "static/media/RG.a1ba3ab0.png";